import { Children as O, createElement as A, Fragment as I } from "react";
import { a as c, i as s, b as x, c as p } from "./core-DVmjA3_O.js";
import { p as d, r as H, c as C } from "./string-CZdwCjMt.js";
import { l as S } from "./transform-DVGbLiBW.js";
import "./type-Dku6Xzl6.js";
import { s as b, b as _ } from "./statistics-IyDYgeE6.js";
import { DEFAULT_DATE_FORMAT as j, KEY_DATE_FORMAT as P } from "./utils/constants.js";
function l(t, e) {
  return function(n, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    const i = c(n) ? t(n) : void 0, o = c(r) ? t(r) : void 0;
    return i === o ? 0 : s(i) ? a * 1 : s(o) ? a * -1 : a * e(i, o);
  };
}
const X = l((t) => t, (t, e) => Number(t) - Number(e)), Z = l((t) => t, (t, e) => t.localeCompare(e)), tt = l((t) => t, (t, e) => t - e), et = l((t) => t, (t, e) => {
  const n = new Date(t), r = new Date(e);
  return n.getTime() - r.getTime();
}), Y = (t, e, n, r) => n ? l((a) => a, (a, i) => {
  const o = n.toLowerCase(), u = a.toLowerCase().indexOf(o), f = i.toLowerCase().indexOf(o);
  return u === f || u === -1 && f === -1 ? a.localeCompare(i) : f === -1 ? -1 : u === -1 ? 1 : u - f;
})(t, e, r) : 0, k = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], V = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var m = /* @__PURE__ */ (function(t) {
  return t.time = "time", t.date = "date", t;
})(m || {});
function y(t, e) {
  let n, r;
  return e.forEach((a) => {
    const i = t.indexOf(a);
    if (i === -1)
      return;
    const o = i + a.length;
    (n === void 0 || i < n) && (n = i), (r === void 0 || o > r) && (r = o);
  }), {
    start: n,
    end: r
  };
}
function F(t) {
  const {
    start: e,
    end: n
  } = y(t, ["yyyy", "yy", "MMM", "MM", "dd", "EEE"]), {
    start: r,
    end: a
  } = y(t, ["hh", "mm", "ss", "aaa"]), i = t.length, o = (u, f) => u === void 0 || f === void 0 ? "" : t.substring(u, f);
  return e === void 0 && r === void 0 ? [{
    value: t
  }].filter((u) => u.value !== "") : e === void 0 ? [{
    value: o(0, r)
  }, {
    type: m.time,
    value: o(r, a)
  }, {
    value: o(a, i)
  }].filter((u) => u.value !== "") : r === void 0 ? [{
    value: o(0, e)
  }, {
    type: m.date,
    value: o(e, n)
  }, {
    value: o(n, i)
  }].filter((u) => u.value !== "") : e < r ? [{
    value: o(0, e)
  }, {
    type: m.date,
    value: o(e, n)
  }, {
    value: o(n, r)
  }, {
    type: m.time,
    value: o(r, a)
  }, {
    value: o(a, i)
  }].filter((u) => u.value !== "") : [{
    value: o(0, r)
  }, {
    type: m.time,
    value: o(r, a)
  }, {
    value: o(a, e)
  }, {
    type: m.date,
    value: o(e, n)
  }, {
    value: o(n, i)
  }].filter((u) => u.value !== "");
}
function L(t, e) {
  return t.map((n) => {
    if (n.type === m.date) {
      const r = e.getFullYear(), a = e.getMonth(), i = e.getDate(), o = V[e.getDay()], u = {
        ...n
      };
      return u.value = u.value.replace("yyyy", String(r)).replace("yy", String(r % 100)).replace("MMM", k[a]).replace("MM", d(a + 1, 2)).replace("EEE", o).replace("dd", d(i, 2)), u;
    }
    if (n.type === m.time) {
      const r = n.value.indexOf("aaa"), a = e.getHours(), i = r >= 0 ? (a - 1) % 12 + 1 : a, o = a >= 12 ? "PM" : "AM", u = e.getMinutes(), f = e.getSeconds(), g = {
        ...n
      };
      return g.value = g.value.replace("hh", d(i, 2)).replace("mm", d(u, 2)).replace("ss", d(f, 2)).replace("aaa", o), g;
    }
    return n;
  });
}
function nt(t) {
  if (!s(t))
    return Math.round(t);
}
function rt(t, e, n = !0) {
  if (s(t) || s(e))
    return;
  if (e === 0)
    return 0;
  const r = t * 100 / e;
  return n ? _(r, 0, 100) : r;
}
function D(t) {
  if (s(t))
    return;
  const e = t.filter(c);
  if (e.length !== 0)
    return e;
}
function at(t) {
  const e = D(t);
  if (!s(e))
    return b(e);
}
function it(t) {
  const e = D(t);
  if (!s(e))
    return Math.max(...e);
}
function ot(t) {
  const e = D(t);
  if (!s(e))
    return Math.min(...e);
}
function ut(t) {
  const e = D(t);
  return s(e) ? void 0 : b(e) / e.length;
}
function st(t, e, n = (r) => r > 1) {
  const r = S(
    t,
    e,
    (a, i, o, u) => {
      const f = u[i];
      return c(f) ? f + 1 : 1;
    }
  );
  return Object.keys(r).filter((a) => n(r[a]));
}
function ft(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function ct(t, e, n) {
  return p(e) ? t : t.filter((r) => C(n(r), e)).sort((r, a) => Y(
    n(r),
    n(a),
    e
  ));
}
function v(t, e, n) {
  return t === 0 ? n ? "" : "0" : `${Intl.NumberFormat("default", { notation: "compact" }).format(t)} ${e}${t !== 1 ? "s" : ""}`;
}
const B = {
  0: {
    shortText: "yr",
    text: "year",
    value: 365 * 24 * 60 * 60
  },
  1: {
    shortText: "mo",
    text: "month",
    value: 720 * 60 * 60
  },
  2: {
    shortText: "day",
    text: "day",
    value: 1440 * 60
  },
  3: {
    shortText: "hr",
    text: "hour",
    value: 3600
  },
  4: {
    shortText: "min",
    text: "minute",
    value: 60
  },
  5: {
    shortText: "sec",
    text: "second",
    value: 1
  }
};
function h(t, e = " ", n = !1, r = 2, a = 0, i = void 0) {
  if (c(i) && a >= i)
    return "";
  if (a === 5)
    return v(t, n ? "sec" : "second", c(i));
  const o = a + 1, u = B[a], f = Math.floor(t / u.value);
  return f >= 1 ? [
    v(f, n ? u.shortText : u.text, c(i)),
    h(
      t % u.value,
      e,
      n,
      r,
      o,
      i ?? a + r
    )
  ].filter(Boolean).join(" ") : h(
    t,
    e,
    n,
    r,
    o,
    i
  );
}
function mt(t, e) {
  const n = e.getTime() - t.getTime(), r = Math.round(n / 1e3);
  return h(r);
}
function dt(t, e) {
  const n = t.toLowerCase().substring(t.lastIndexOf("@") + 1);
  return e.filter((r) => r.is_active).map((r) => r.domain_name.toLowerCase()).includes(n);
}
function M(t) {
  if (t < 1e3)
    return 2;
  const r = new Intl.NumberFormat("default", { notation: "compact" }).formatToParts(t).find(({ type: a }) => a === "fraction");
  return s(r) || p(r.value) ? 0 : Number(r.value) > 0.1 ? 1 : 0;
}
function lt(t, e) {
  if (s(t))
    return;
  const n = {};
  if (s(e))
    return n.maximumFractionDigits = M(t), new Intl.NumberFormat("default", n).format(t);
  const {
    currency: r,
    unit: a,
    maximumFractionDigits: i,
    compact: o,
    separatorHidden: u,
    language: f
  } = e;
  return x(a) && (n.unit = a, n.unitDisplay = "short"), r && (n.currencyDisplay = "narrowSymbol", n.style = "currency"), o && (n.notation = "compact", n.compactDisplay = "short"), n.useGrouping = !u, c(i) ? n.maximumFractionDigits = i : n.maximumFractionDigits = M(t), new Intl.NumberFormat(f, n).format(t);
}
function E(t, e = j) {
  if (s(t))
    return;
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? void 0 : L(F(e), n).map((i) => i.value).join("");
}
function gt(t) {
  if (s(t))
    return;
  const e = new Date(t);
  return Number.isNaN(e.getTime()) ? void 0 : L(F("yyyy-MM-dd"), e).map((i) => i.value).join("");
}
function Dt(t, e, n = !1) {
  const r = t.map(
    (a, i) => e(a, i) ? i : void 0
  ).filter(c);
  return r.length === 0 ? [t] : [...r, t.length].map(
    (a, i) => {
      const o = i === 0 ? 0 : r[i - 1] + (n ? 0 : 1);
      return o === a ? void 0 : t.slice(o, a);
    }
  ).filter(c);
}
function ht(t, e) {
  return new Date(t, e + 1, 0).getDate();
}
function pt(t) {
  return {
    ...t,
    client_id: t.client_id ?? (c(t.id) ? String(t.id) : void 0) ?? H()
  };
}
function yt() {
  return E(/* @__PURE__ */ new Date(), "MM/yyyy");
}
function vt(t = "long") {
  return Array.from(Array(12).keys()).map(
    (n) => {
      const r = /* @__PURE__ */ new Date();
      return r.setDate(1), r.setMonth(n), r.setHours(0, 0, 0, 0), {
        key: n,
        label: r.toLocaleString(
          "default",
          { month: t }
        )
      };
    }
  );
}
function Mt(t, e, n) {
  return t.map((a) => e(a).map((o) => n(a, o))).flat();
}
function N(t) {
  return s(t) ? !1 : typeof t == "boolean" ? !0 : typeof t == "number" ? !Number.isNaN(t) : typeof t == "string" ? x(t.trim()) : Array.isArray(t) ? t.length === 0 ? !1 : t.some(N) : typeof t == "object" && t ? Object.values(t).some(N) : !1;
}
function Nt(t, e) {
  const n = O.toArray(t).reduce(
    (r, a, i, o) => (s(a) || (r.push(a), i < o.length - 1 && r.push(e)), r),
    []
  );
  return A(
    I,
    {},
    ...n
  );
}
function wt(t, e) {
  if (!t && !e)
    return !0;
  if (!t || !e || t.length !== e.length)
    return !1;
  if (t.length === 0 && e.length === 0)
    return !0;
  const n = S(
    t,
    (r) => r,
    () => !0
  );
  return e.every((r) => n[r]);
}
const Tt = {
  en: "English",
  fr: "French",
  es: "Spanish",
  ar: "Arabic"
};
function xt(t) {
  if (!p(t))
    return t.includes("T") ? new Date(t).toISOString() : (/* @__PURE__ */ new Date(`${t}T00:00:00`)).toISOString();
}
function St(t, e) {
  if (s(t) || s(e))
    return;
  const n = new Date(t);
  if (!Number.isNaN(n))
    return n.setDate(1), n.setMonth(
      n.getMonth() + e + 1
    ), n.setDate(0), n.setHours(0, 0, 0, 0), n;
}
function bt(t, e) {
  if (s(t) || s(e))
    return;
  const n = new Date(t);
  if (!Number.isNaN(n.getTime()))
    return n.setDate(n.getDate() + e), n;
}
function Ft(t) {
  if (s(t))
    return;
  const e = new Date(t);
  if (!Number.isNaN(e.getTime()))
    return e.setMonth(e.getMonth() + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function Lt(t) {
  if (s(t))
    return !1;
  const e = new Date(t);
  return !Number.isNaN(e.getTime());
}
function Et(t) {
  return E(t, P) ?? "??";
}
function J(t, e = 1) {
  const n = new Date(t);
  return n.setDate(t.getDate() + e), n.setHours(0, 0, 0, 0), n;
}
function Ot(t, e = 1) {
  const n = new Date(t);
  return n.setDate(1), n.setMonth(t.getMonth() + e), n.setHours(0, 0, 0, 0), n;
}
function K(t, e) {
  const n = new Date(t);
  n.setHours(0, 0, 0, 0);
  const r = new Date(e);
  r.setHours(0, 0, 0, 0);
  let a = 0;
  for (let i = n; i < r; i = J(i))
    a += 1;
  return a;
}
function W(t, e) {
  return Math.abs(
    12 * e.getFullYear() + e.getMonth() - (12 * t.getFullYear() + t.getMonth())
  );
}
function At(t, e) {
  const n = new Date(t), r = new Date(e), a = r.getFullYear() - n.getFullYear(), i = W(n, r), o = K(n, r);
  return {
    year: a,
    month: i,
    day: o
  };
}
function w(t) {
  return !(s(t) || t === "");
}
function T(t) {
  return !!(s(t) || t === "");
}
function It(t, e, n) {
  if (n) {
    if (T(e) && w(t))
      return "add";
    if (T(t) && w(e))
      return "remove";
    if (t !== e)
      return "update";
  }
}
export {
  dt as A,
  Nt as B,
  Tt as C,
  it as D,
  ot as E,
  ct as F,
  nt as G,
  Dt as H,
  at as I,
  xt as J,
  X as K,
  et as L,
  tt as M,
  Z as N,
  bt as a,
  St as b,
  ut as c,
  Ft as d,
  Mt as e,
  gt as f,
  E as g,
  lt as h,
  yt as i,
  st as j,
  mt as k,
  Et as l,
  It as m,
  vt as n,
  K as o,
  ht as p,
  W as q,
  rt as r,
  At as s,
  N as t,
  J as u,
  Ot as v,
  pt as w,
  ft as x,
  wt as y,
  Lt as z
};
